import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { HostListener, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoggerService } from '../services/logger.service';

@Injectable()
export class HttperrorInterceptor implements HttpInterceptor {
    constructor (
        private logger: LoggerService
    ) { }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event): any {
        this.logger.logCurrentContents();
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request)
            .pipe();
    }
}
